module.exports = __webpack_public_path__ + "img/product-1-thumb-4.9ebafa75.jpg";